import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Bookmark } from "../components/ReusableElements";

const SuccessConfirmation = (props) => {
  return (
    <div className="Home">
      <Bookmark />
      <h1>{props.title}</h1>
      <h2> Redirecting in {props.countdown} seconds...</h2>
    </div>
  );
};

class Confirmation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timer: 5,
    };
  }

  handleCountdown() {
    var self = this;
    var timer = setInterval(increment, 1000);

    function increment() {
      if (self.state.timer === 0) {
        clearInterval(timer);
        console.log(self.props);
        self.props.history.push(self.props.location.state.redirectURI || "/");
      } else {
        self.setState({ timer: self.state.timer - 1 });
      }
    }
  }

  componentDidMount() {
    this.handleCountdown();
  }

  render() {
    return (
      <SuccessConfirmation
        title={
          this.props.location.state.success === true
            ? "Success!"
            : this.props.location.state.success === 2
            ? "Account already registered and pending approval."
            : "Failure!"
        }
        countdown={this.state.timer}
      />
    );
  }
}

export default withRouter(Confirmation);



// WEBPACK FOOTER //
// ./src/containers/Confirmation.js